import { useTranslate } from "@refinedev/core";
import { Card, Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { StyledTitle } from "./ListPanel";
import { CreatePrimaryButton } from "components/CreatePrimaryButton";
import { radius } from "@libertify/ui";

export const ItemCreateCard = ({
  itemName,
  title,
  description,
}: {
  itemName: string;
  title: string;
  description: string;
}) => {
  const t = useTranslate();
  const { theme, isMobile } = useAntTheme();
  const createItemText = t("pages.components.ListPanel.createItem", {
    item: itemName,
  });
  return (
    <Card
      style={{
        width: isMobile ? "100%" : "25%",
        border: "none",
        height: "fit-content",
      }}
    >
      <StyledTitle>{createItemText}</StyledTitle>
      <Flex
        style={{
          backgroundColor: `${theme.colorInfoBg}80`,
          padding: "24px 14px",
          marginTop: 10,
          borderRadius: radius.box,
        }}
        gap={8}
        vertical
      >
        <Typography.Text style={{ fontWeight: 500 }}>{title}</Typography.Text>
        <Typography.Text style={{ lineHeight: 1.1 }}>
          {description}
        </Typography.Text>
        <CreatePrimaryButton
          textStyle={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
          style={{ marginTop: 10, maxWidth: "100%" }}
        >
          {createItemText}
        </CreatePrimaryButton>
      </Flex>
    </Card>
  );
};
